<template>
	<div>
		<ul class="pt-4 font-bold text-cyan underline text-left">
			<li class="py-2" v-for="{urlText, id} in this.data" :key="id">
				<span class="">{{urlText}}</span>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	name: 'link-list',
	props: {
		data: {
			type: Array
		},
		iconName: {
			type: String
		}
	}
}
</script>
<style lang="postcss" scoped>
</style>